module.exports = __webpack_public_path__ + "static/media/default_picture_RM_quizz.aaacac9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/default_picture_RM_quizz.png
// module id = 494
// module chunks = 0